const AutonomousTerritory = require('./AutonomousTerritory');
const DevelopedTerritory = require('./DevelopedTerritory');
const HistoricTerritory = require('./HistoricTerritory');
const InhabitedTerritory = require('./InhabitedTerritory');
const StrategicTerritory = require('./StrategicTerritory');
const VastTerritory = require('./VastTerritory');
const WealthyTerritory = require('./WealthyTerritory');

module.exports = {
    AutonomousTerritory,
    DevelopedTerritory,
    HistoricTerritory,
    InhabitedTerritory,
    StrategicTerritory,
    VastTerritory,
    WealthyTerritory
}